import { cn } from '@/lib/utils';
import { UserPlus, User } from 'lucide-react';

interface CustomerStatCardProps {
  title: string;
  value: string | number;
  trendValue?: string;
  variant?: 'hot' | 'warm' | 'cold' | 'total';
  className?: string;
}

function CustomerStatCard({
  title,
  value,
  trendValue,
  variant = 'total',
  className,
}: CustomerStatCardProps) {
  const showPlusIcon = variant !== 'total';

  return (
    <div
      className={cn(
        'flex flex-col gap-4 justify-between w-full rounded-2xl p-6 text-white',
        className,
        { 'bg-red-600': variant === 'hot' },
        { 'bg-yellow-500': variant === 'warm' },
        { 'bg-blue-500': variant === 'cold' },
        { 'bg-green-500': variant === 'total' }
      )}
    >
      <div className="flex justify-between items-start">
        <h5 className="text-base font-medium">{title}</h5>
        <div className="w-10 h-10 bg-white rounded-full shrink-0 flex items-center justify-center">
          {showPlusIcon ? (
            <UserPlus
              className={cn(
                'w-5 h-5',
                { 'text-red-600': variant === 'hot' },
                { 'text-yellow-500': variant === 'warm' },
                { 'text-blue-500': variant === 'cold' }
              )}
            />
          ) : (
            <User className="w-7 h-7 text-green-500" />
          )}
        </div>
      </div>
      <p className="font-bold text-2xl leading-none">{value}</p>
      {trendValue && (
        <p className="text-xs font-normal">{trendValue} from last month</p>
      )}
    </div>
  );
}

export { CustomerStatCard };
